export default "__VITE_ASSET__BBnCYW8e__"